module.exports = function isFunction(x) {
  return typeof x === 'function';
};